import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Button, View } from '../../../../../core/components/Index';
import { useNavigate, useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Appl } from '../../../../../core/Appl';
import EstimateDetailsViewModel from './EstimateDetailsViewModel';
import Helper, { formatDate } from '../../../../../core/services/Helper';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../../../../core/components/OptionSelectionAccordian';
import { AppPermissions } from '../../../../../core/services/AppPermissions';
import SpcModule from '../../SpcModule';

export const EstimateDetails: React.FC = observer(() => {
  const vm = Appl.Services.get<EstimateDetailsViewModel>('EstimateDetailsViewModel');
  vm.navigate = useNavigate();
  let { spcTypeSubId } = useParams();
  // const [openIndexes, setOpenIndexes] = useState<{ [key: number]: boolean }>({});

  useAsyncEffect(async () => {
    await vm.initAsync(spcTypeSubId!);
    // if (vm.model.estimateDetails) {
    //   const initialState: { [key: number]: boolean } = {};
    //   vm.model.estimateDetails.forEach((_, index) => {
    //     initialState[index] = true;
    //   });
    //   setOpenIndexes(initialState);
    // }
  }, []);

  function formatFinancialYear(fy: string) 
  {
    const parts = fy.split('-');
    if (parts.length === 2) 
    {
      let firstYear = parseInt(parts[0].replace('FY',""));
      let secondYear = firstYear+1;
      return `FY ${firstYear}/${secondYear}`;
    }
  }

  function LeavePeriodSection() 
  {
    //Rendering no accordion if only one breakdown exists: 
    const breakdowns = vm.model.finalEstimate?.estimateBreakdowns ?? [];
    const isSingle = breakdowns.length === 1;

    if (isSingle) 
    {
      const estBreakdown = breakdowns[0];

      return (
        <div className="w-full max-w-[849px]">
          <div className="pt-[20px] flex flex-col md:flex-row gap-[12px] mb-[0px]">
                      {/* ---------- LEFT SIDE (Member Provided) ---------- */}
                      <div className="w-full md:w-[49%] pl-[24px]">
                        <p className="text-[15px] font-semibold mb-[24px]">
                          Member Provided
                        </p>
                        {/* Type 1 */}
                        {estBreakdown.spcTypeId === 1 && (
                          <ul className="list-disc pl-[10px] space-y-[0px] text-[15px] leading-[175%]">
                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Employer:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.employer}
                                    </span>
                                </div>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Membership Tier:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.membershipTier}
                                    </span>
                                </div>
                              </li>
                              <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Medical Leave Period:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                       {estBreakdown.leavePeriodFrom && estBreakdown.leavePeriodTo
                                        ? `${formatDate(estBreakdown.leavePeriodFrom)} – ${formatDate(estBreakdown.leavePeriodTo)}`
                                        : ""}
                                    </span>
                                </div>
                              </li>
                               <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Estimated Hours of Leave:
                                   </span>

                                    <span className="font-bold tracking--1_5percent break-words">
                                       {Helper.formatWholeNumber(estBreakdown.estimatedHoursOfLeave)}
                                    </span>
                                </div>
                              </li>

                              <li className="flex items-start gap-2">

                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                    Compensation Used:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {Helper.formatCurrency(estBreakdown.compensationUsed)} {estBreakdown.compensationFrequency}
                                    </span>
                                </div>
                              </li>
                          </ul>
                        )}

                        {/* Type 2 */}
                          {estBreakdown.spcTypeId === 2 && (
                            <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                              <li className="flex items-start gap-2">
                                {/* Bullet */}
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                {/* Label + value */}
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  {/* Label: never wrap */}
                                  <span className="whitespace-nowrap">
                                    Employer:
                                  </span>

                                  {/* Value: wraps and hangs left */}
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.employer}
                                  </span>
                                </div>
                              </li>

                              <li className="flex items-start gap-2">

                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                   Membership Entry Date:
                                   </span>

                                    <span className="font-bold tracking--1_5percent break-words">
                                      {formatDate(estBreakdown.mbrEntryDate)}
                                    </span>
                                </div>
                              </li>

                              <li className="flex items-start gap-2">

                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                   Membership Tier:
                                   </span>

                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.membershipTier}
                                    </span>
                                </div>
                              </li>

                              <li className="flex items-start gap-2">

                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                   Date of Employment:
                                   </span>

                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.leavePeriodFrom && estBreakdown.leavePeriodTo
                                    ? `${formatDate(estBreakdown.leavePeriodFrom)} – ${formatDate(estBreakdown.leavePeriodTo)}`
                                    : ""}
                                    </span>
                                </div>
                              </li>

                              <li className="flex items-start gap-2">

                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Estimated Hours of Leave:
                                   </span>

                                    <span className="font-bold tracking--1_5percent break-words">
                                      {Helper.formatWholeNumber(estBreakdown.estimatedHoursOfLeave)}
                                    </span>
                                </div>
                              </li>

                              <li className="flex items-start gap-2">

                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />

                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Compensation Used:
                                   </span>

                                    <span className="font-bold tracking--1_5percent break-words">
                                      {Helper.formatCurrency(estBreakdown.compensationUsed)} {estBreakdown.compensationFrequency}
                                    </span>
                                </div>
                              </li>
                            </ul>
                          )}

                        {/* Type 3 */}
                        {estBreakdown.spcTypeId === 3 && (
                          <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">
                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Withdrawal Date:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {formatDate(estBreakdown.withdrawDate)}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Amount Withdrawn:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {Helper.formatCurrency(estBreakdown.withdrawAmount)}
                                    </span>
                                </div>
                            </li>
                          </ul>
                        )}

                        {/* Type 4 */}
                        {estBreakdown.spcTypeId === 4 && (
                          <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Membership Entry Date:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {formatDate(estBreakdown.mbrEntryDate)}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Membership Tier at Entry:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                       {estBreakdown.membershipTier}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Employer:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                       {estBreakdown.employer}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Date of Service:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                       {estBreakdown.leavePeriodFrom && estBreakdown.leavePeriodTo
                                        ? `${formatDate(estBreakdown.leavePeriodFrom)} – ${formatDate(estBreakdown.leavePeriodTo)}`
                                        : ""}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Est. Hours:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                       {Helper.formatWholeNumber(estBreakdown.estimatedHoursOfLeave)}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Est. Compensation:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {Helper.formatCurrency(estBreakdown.compensationUsed)} {estBreakdown.compensationFrequency}
                                    </span>
                                </div>
                            </li>
                          </ul>
                        )}
                      </div>

                      {/* ---------- RIGHT SIDE (System Applied) ---------- */}
                      <div className="w-full md:w-[49%] pl-[24px]">
                        <p className="text-[15px] font-semibold mb-[24px]">
                          System Provided
                        </p>
                        <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">
                        {estBreakdown.leaveSegments?.map(function (leaveSegment, ind) {
                          return (
                            <React.Fragment key={ind}>

                              {estBreakdown.spcTypeId !== 3 && (
                                <li className="flex items-start gap-2">
                                    <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                    <div className="flex flex-col md:flex-row md:gap-1">
                                      <span className="whitespace-nowrap">
                                          Contribution Rate ({formatFinancialYear(leaveSegment?.fiscalYear!)}):
                                      </span>
                                        <span className="font-bold tracking--1_5percent break-words">
                                          {leaveSegment?.contributionRate != null
                                            ? (leaveSegment.contributionRate * 100).toFixed(2) + "%"
                                            : ""}
                                        </span>
                                    </div>
                                </li>
                              )}

                            </React.Fragment>
                          );
                        })}

                        {estBreakdown.leaveSegments &&
                          estBreakdown.leaveSegments.length > 0 && (
                             <li className="flex items-start gap-2">
                                    <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                    <div className="flex flex-col md:flex-row md:gap-1">
                                      <span className="whitespace-nowrap">
                                          Interest Factor:
                                      </span>
                                      <span className="tracking--1_5percent">
                                        <span className='font-bold'>
                                          {estBreakdown.leaveSegments[0].compoundInterestFactor?.toFixed(5)}
                                        </span>
                                        <span className='!font-normal'>
                                            {" "}({formatDate(estBreakdown.leaveSegments[0]?.startDate)} to present)
                                        </span>
                                      </span>
                                    </div>
                                </li>
                            
                          )}

                          {estBreakdown.spcTypeId !== 3 && (
                              <li className="flex items-start gap-2">
                                    <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                    <div className="flex flex-col md:flex-row md:gap-1">
                                      <span className="whitespace-nowrap">
                                          Hourly Compensation:
                                      </span>
                                      <span className="tracking--1_5percent">
                                        <span className='font-bold'>
                                          {Helper.formatCurrency(estBreakdown.hourlyPay)}
                                        </span>
                                      </span>
                                    </div>
                                </li>
                            )}

                      </ul>

                      </div>

                    </div>
                  {/* <div className="w-full max-w-[849px] border-t-[1px] border-[#D6D6D6] mt-[20px]"></div> */}
                </div>
              );
    }

    else {
      return (
        <Accordion type="multiple" className="w-full max-w-[849px]">

          {vm.model.finalEstimate?.estimateBreakdowns?.map(function(estBreakdown, index) 
          {
            let titleText: React.ReactNode = `Leave Period ${index + 1} - Estimate: ${Helper.formatCurrency(estBreakdown.estimate ?? 0)}`;

            if (estBreakdown.spcTypeId === 3) 
            {
              titleText = (
                      <>
                        {/* Mobile */}
                        <span className="hidden md:block">
                          Withdrawal Contributions {index + 1} - Estimate:{" "}
                          {Helper.formatCurrency(estBreakdown.estimate ?? 0)}
                        </span>

                        {/* md+ */}
                        <div className="md:hidden">
                          <div>Withdrawal Contributions {index + 1}</div>
                          <div>
                            - Estimate: {Helper.formatCurrency(estBreakdown.estimate ?? 0)}
                          </div>
                        </div>
                      </>
                      );
            } 

            return (
              <AccordionItem 
                key={`period-${index}`} 
                value={`period-${index}`} 
                withBorder={false}
              >
              
                  {/* ---------- Trigger ---------- */}
                  <AccordionTrigger className="px-0">
                    <div className="flex w-full items-start text-left">
                      <div className="text-[15px] font-bold">
                        {titleText}
                      </div>
                    </div>
                  </AccordionTrigger>

                  <div className="w-full border-b-[1px] border-[#D6D6D6] mt-[0px]"></div>

                 <AccordionContent>
                    <div className="pt-[20px] flex flex-wrap gap-[12px] mb-[0px]">

                      {/* ---------- LEFT SIDE (Member Provided) ---------- */}
                      <div className="w-full md:w-[49%] pl-[24px]">

                        <p className="text-[15px] font-semibold mb-[24px]">
                          Member Provided
                        </p>

                        {/* ---------- TYPE 1 ---------- */}
                        {estBreakdown.spcTypeId === 1 && (
                          <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Employer:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.employer}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Membership Tier:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.membershipTier}
                                    </span>
                                </div>
                            </li>

                            <li className="flex items-start gap-2">
                                <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                <div className="flex flex-col md:flex-row md:gap-1">
                                  <span className="whitespace-nowrap">
                                      Medical Leave Period:
                                   </span>
                                    <span className="font-bold tracking--1_5percent break-words">
                                      {estBreakdown.leavePeriodFrom && estBreakdown.leavePeriodTo
                                      ? `${formatDate(estBreakdown.leavePeriodFrom)} – ${formatDate(estBreakdown.leavePeriodTo)}`
                                      : ""}
                                    </span>
                                </div>
                            </li>
                            
                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Estimated Hours of Leave:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {Helper.formatWholeNumber(estBreakdown.estimatedHoursOfLeave)}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Compensation Used:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                  {Helper.formatCurrency(estBreakdown.compensationUsed)} {estBreakdown.compensationFrequency}
                                  </span>
                              </div>
                            </li>
                          </ul>
                        )}

                        {/* ---------- TYPE 2 ---------- */}
                        {estBreakdown.spcTypeId === 2 && (
                          <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Employer:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.employer}
                                  </span>
                              </div>
                            </li>

                             <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Membership Entry Date:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {formatDate(estBreakdown.mbrEntryDate)}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Membership Tier:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.membershipTier}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Date of Employment:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.leavePeriodFrom && estBreakdown.leavePeriodTo
                                      ? `${formatDate(estBreakdown.leavePeriodFrom)} – ${formatDate(estBreakdown.leavePeriodTo)}`
                                      : ""}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                   Estimated Hours of Leave:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {Helper.formatWholeNumber(estBreakdown.estimatedHoursOfLeave)}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                   Compensation Used:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {Helper.formatCurrency(estBreakdown.compensationUsed)} {estBreakdown.compensationFrequency}
                                  </span>
                              </div>
                            </li>

                          </ul>
                        )}

                        {/* ---------- TYPE 3 ---------- */}
                        {estBreakdown.spcTypeId === 3 && (
                          <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  Withdrawal Date:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                  {formatDate(estBreakdown.withdrawDate)}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  Amount Withdrawn:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {Helper.formatCurrency(estBreakdown.withdrawAmount)}
                                  </span>
                              </div>
                            </li>
                          </ul>
                        )}

                        {/* ---------- TYPE 4 ---------- */}
                        {estBreakdown.spcTypeId === 4 && (
                          <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  Membership Entry Date:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {formatDate(estBreakdown.mbrEntryDate)}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  Membership Tier at Entry:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.membershipTier}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  SCERS Employer:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.employer}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  Date of Service:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {estBreakdown.leavePeriodFrom && estBreakdown.leavePeriodTo
                                    ? `${formatDate(estBreakdown.leavePeriodFrom)} – ${formatDate(estBreakdown.leavePeriodTo)}`
                                    : ""}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                  Est. Hours:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {Helper.formatWholeNumber(estBreakdown.estimatedHoursOfLeave)}
                                  </span>
                              </div>
                            </li>

                            <li className="flex items-start gap-2">
                              <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                              <div className="flex flex-col md:flex-row md:gap-1">
                                <span className="whitespace-nowrap">
                                    Est. Compensation:
                                  </span>
                                  <span className="font-bold tracking--1_5percent break-words">
                                    {Helper.formatCurrency(estBreakdown.compensationUsed)} {estBreakdown.compensationFrequency}
                                  </span>
                              </div>
                            </li>
                          </ul>
                        )}

                      </div>

                      {/* ---------- RIGHT SIDE (System Applied) ---------- */}
                      <div className="w-full md:w-[49%] pl-[24px]">

                        <p className="text-[15px] font-semibold mb-[24px]">
                          System Provided
                        </p>

                        <ul className="pl-[10px] space-y-[0px] text-[15px] leading-[175%]">

                          {estBreakdown.leaveSegments?.map(function (leaveSegment, ind) {
                            return (
                              <React.Fragment key={ind}>
                                {estBreakdown.spcTypeId !== 3 && (
                                  <li className="flex items-start gap-2">
                                    <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                    <div className="flex flex-col md:flex-row md:gap-1">
                                      <span className="whitespace-nowrap">
                                          Contribution Rate ({formatFinancialYear(leaveSegment?.fiscalYear!)}):
                                        </span>
                                        <span className="font-bold tracking--1_5percent break-words">
                                          {leaveSegment?.contributionRate != null
                                        ? (leaveSegment.contributionRate * 100).toFixed(2) + "%"
                                        : ""}
                                        </span>
                                    </div>
                                  </li>
                                )}
                              </React.Fragment>
                            );
                          })}

                            {estBreakdown.leaveSegments &&
                            estBreakdown.leaveSegments.length > 0 && (
                              <li className="flex items-start gap-2">
                                    <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                    <div className="flex flex-col md:flex-row md:gap-1">
                                      <span className="whitespace-nowrap">
                                          Interest Factor:
                                      </span>
                                      <span className="tracking--1_5percent">
                                        <span className='font-bold'>
                                          {estBreakdown.leaveSegments[0].compoundInterestFactor?.toFixed(5)}
                                        </span>
                                        <span className='!font-normal'>
                                            {" "}({formatDate(estBreakdown.leaveSegments[0]?.startDate)} to present)
                                        </span>
                                      </span>
                                    </div>
                                </li>
                            )}

                            {estBreakdown.spcTypeId !== 3 && (
                              <li className="flex items-start gap-2">
                                    <span className="mt-[10px] block h-1 w-1 rounded-full bg-black flex-shrink-0" />
                                    <div className="flex flex-col md:flex-row md:gap-1">
                                      <span className="whitespace-nowrap">
                                          Hourly Compensation:
                                      </span>
                                      <span className="tracking--1_5percent">
                                        <span className='font-bold'>
                                          {Helper.formatCurrency(estBreakdown.hourlyPay)}
                                        </span>
                                      </span>
                                    </div>
                                </li>
                            )}

                        </ul>
                      </div>
                    </div>
                  </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      );
    }
}

  return (
    <>
   <View id="EstimateDetails" pageTitle={vm.pageTitle}
        authKey={AppPermissions.AuthenticatedUser}
        showMenuBar={false}
        menuItems={SpcModule.MenuItems()}
      >
      <div className="max-w-full mx-auto w-full max-w-[880px] p-[10px]">
        <div>
          <h1 className="text-[32px] tracking-[-1%] text-[#363636] !font-semibold mb-4">
            {vm.pageTitle}
          </h1>
          <p className="tracking--1percent"></p>
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col items-left mt-[20px] w-[450px]">
            <p className="text-[28px] font-bold leading-[120%] mb-[20px]">
              Estimate Summary
            </p>
          <p className='mb-[5px]'>Purchase Type: {vm.model?.finalEstimate?.spcTypeName}</p>
          <p className='mb-[5px]'>Member: {vm.model?.finalEstimate?.memberName}</p>
          <p>Email: {vm.model?.finalEstimate?.memberEmail}</p>
        </div>
      <div className="flex flex-col items-center mt-[20px]">
          <div className="shadow-xl mt-[24px] w-full max-w-[604px] min-w-[404px] min-h-[127px] bg-[#F7F3ED] border border-[#CF7119] border-l-[10px] rounded-[10px] px-[24px] py-[20px] flex flex-col items-center justify-center gap-[8px]">
            <p className="text-center text-[18px] font-bold leading-[120%] m-0">
              Purchase Estimate
            </p>
            <p className="text-center text-[clamp(30px,6vw,40px)] font-bold leading-[100%] m-0">
              {Helper.formatCurrency(vm.model?.finalEstimate?.purchaseEstimate ?? 0)}
            </p>
          </div>
        </div>
        </div>
        <div className="mt-[50px]">
          <div>
            <LeavePeriodSection />
            <div className="text-[18px] font-bold leading-[120%] mt-[30px]">
              TOTAL ESTIMATE: {Helper.formatCurrency(vm.model?.finalEstimate?.purchaseEstimate ?? 0)}
              <div className="w-full max-w-[849px] border-t-[1px] border-[#D6D6D6] mt-[5px]"></div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex mt-6 flex-wrap gap-[24px] sm:flex-nowrap">
            <Button 
              className='w-[146px] h-[39px]'
              title="View PDF" 
              onClick={async () => {
                await vm.onPrintEstimateAsync();
              }}
            />
            <Button 
              title="Back to Queue" 
              className='w-[146px] h-[39px]' 
              severity='warning' 
              outlined 
              onClick={() => vm.navigate(`/spc/spc-queue`)} 
            />
          </div>
        </div>
      </div>
      </View>
    </>
  );

});
